import { render } from "./TextareaGroup.vue?vue&type=template&id=da0feee0&scoped=true"
import script from "./TextareaGroup.vue?vue&type=script&lang=js"
export * from "./TextareaGroup.vue?vue&type=script&lang=js"

import "./TextareaGroup.vue?vue&type=style&index=0&id=da0feee0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da0feee0"]])

export default __exports__